import type { TicTacToeView } from '@minigame-race/contracts';
import type { MinigameProps } from '../../race/types.js';
import { TicTacToeBoard } from '../../turn/TicTacToeBoard.js';
import { TurnBoardFrame } from '../../turn/TurnBoardFrame.js';

/** Tic-Tac-Toe as a race segment. See ConnectFourGame for the turn-adapter note. */
export function TicTacToeGame({ view, emit }: MinigameProps) {
  const v = view as TicTacToeView | null;
  if (!v) return null;
  return (
    <TurnBoardFrame>
      <TicTacToeBoard view={v} yourSeat={v.yourSeat} yourTurn={v.yourTurn} onMove={emit} />
    </TurnBoardFrame>
  );
}
